<template>
  <div :class="{ 'tag': true, 'selected': selected == index }" @click="onClick">{{ name }}</div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    index: Number,
    name: String,
    selected: Number
  },
  methods: {
    onClick() {
      this.$emit('select');
    }
  }
}
</script>

<style lang="scss" scoped>
.tag {
  border: 2px solid #dad8d8;
  font-size: 1.4rem;
  color: #bebebe;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  border-radius: 0.3rem;
  transition: 0.3s;
  margin-left: 0.4rem;

  @media (max-width: 550px) {
    font-size: 1.2rem;
    margin-top: 0.6rem;
  }

  &:hover {
    cursor: pointer;
    border: 2px solid #bebebe;
    color: #b8b8b8;
  }
}

.selected {
  border: 2px solid #11B6A5;
  color: #11B6A5;
  &:hover {
    border: 2px solid #11B6A5;
    color: #11B6A5;
  }
}
</style>